import styled from 'styled-components'

export const ContainerSelecao = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .texto__selecao {
    margin: 0;
    padding: 0;
    font-size: 13px;
    line-height: 1.5;
    color: var(--text-color, #303030);
  }
`

export const FooterSelecao = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding-top: 6px;
`
